
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/new_year",
      function () {
        return require("private-next-pages/features/new_year.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/new_year"])
      });
    }
  